import { apiRequest } from './apiClient';

function toQuery(params = {}) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.set(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

// `type` is 'distributor' or 'super-stockist'.
// Returns the full envelope { success, data, pagination }.
export const fetchEnquiries = (params) => apiRequest(`/enquiries/export${toQuery(params)}`);

export const fetchFilterOptions = async type =>
  (await apiRequest(`/enquiries/${type}/filter-options`)).data;

export const updateEnquiryStatus = async (type, id, status) =>
  (await apiRequest(`/enquiries/${type}/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status }) })).data;

export const bulkUpdateStatus = (type, ids, status) =>
  apiRequest(`/enquiries/${type}/bulk-status`, { method: 'PATCH', body: JSON.stringify({ ids, status }) });

export const deleteEnquiry = (type, id) =>
  apiRequest(`/enquiries/${type}/${id}`, { method: 'DELETE' });

export const fetchBin = async type =>
  (await apiRequest(`/enquiries/${type}/bin`)).data;

export const restoreFromBin = (type, ids) =>
  apiRequest(`/enquiries/${type}/bin/restore`, { method: 'PATCH', body: JSON.stringify({ ids }) });

export const permanentlyDeleteFromBin = (type, ids) =>
  apiRequest(`/enquiries/${type}/bin`, { method: 'DELETE', body: JSON.stringify({ ids }) });

export const exportEnquiries = (type, params, format) =>
  apiRequest(`/enquiries/${type}/export${toQuery({ ...params, format })}`);

export const importEnquiries = (type, file) => {
  const body = new FormData();
  body.append('file', file);
  return apiRequest(`/enquiries/${type}/import`, { method: 'POST', body });
};

export const fetchImportTemplate = type => apiRequest(`/enquiries/${type}/import-template`);
